import React from "react";

const SvgPlayerPlaySegment = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1rem"
    height="1rem"
    viewBox="0 0 16 16"
    fill="currentColor"
    style={{ display: "block" }}
  >
    <g transform="translate(1 1)">
      <path
        d="M2 2v10h2v2H0V0h4v2H2zm12-2v14h-4v-2h2V2h-2V0h4zM5 11V3l5 4-5 4z"
        fill="currentColor"
      />
    </g>
  </svg>
);
export default SvgPlayerPlaySegment;
